import { render, staticRenderFns } from "./OogLoiPop.vue?vue&type=template&id=57a15b94"
import script from "./OogLoiPop.vue?vue&type=script&lang=js"
export * from "./OogLoiPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a15b94')) {
      api.createRecord('57a15b94', component.options)
    } else {
      api.reload('57a15b94', component.options)
    }
    module.hot.accept("./OogLoiPop.vue?vue&type=template&id=57a15b94", function () {
      api.rerender('57a15b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/OogLoiPop.vue"
export default component.exports